function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function getAccuracy(solvedCorrectly, puzzlesCompleted) {
  if (!Number.isFinite(puzzlesCompleted) || puzzlesCompleted <= 0) {
    return 0;
  }

  const solved = Number.isFinite(solvedCorrectly) ? solvedCorrectly : 0;
  return clamp(Math.round((solved / puzzlesCompleted) * 100), 0, 100);
}

function getMinutes(seconds) {
  const safeSeconds = Number.isFinite(seconds) ? seconds : 0;
  return Math.max(0, Math.round(safeSeconds / 60));
}

export function buildPerformanceChartData(cycles = [], currentCycle) {
  const data = cycles.map((cycle) => ({
    cycleNumber: cycle.cycleNumber,
    accuracy: getAccuracy(cycle.solvedCorrectly, cycle.puzzlesCompleted),
    timeSpent: getMinutes(cycle.timeSpent),
  }));

  if (currentCycle && Number.isFinite(currentCycle.cycleNumber)) {
    const currentEntry = {
      cycleNumber: currentCycle.cycleNumber,
      accuracy: clamp(
        Math.round(Number.isFinite(currentCycle.accuracy) ? currentCycle.accuracy : 0),
        0,
        100
      ),
      timeSpent: getMinutes(currentCycle.timeSpent),
    };
    const existingIndex = data.findIndex(
      (entry) => entry.cycleNumber === currentCycle.cycleNumber
    );

    if (existingIndex >= 0) {
      data[existingIndex] = currentEntry;
    } else {
      data.push(currentEntry);
    }
  }

  return data;
}
